import React, { Fragment } from 'react';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CheckIcon from '@mui/icons-material/Check';
import { InputLabel, Tooltip } from '@mui/material';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import { StickyMenuItem } from './ActionableSelect.styled';

export interface ActionableSelectOption {
  id: string;
  label: string;
  onClick?: () => void;
}

interface ActionableSelectProps {
  inputLabel: string;
  options: ActionableSelectOption[];
  disabled?: boolean;
  editOptions?: boolean;
  editOptionsLabel?: string;
  value?: string;
  tooltipTitle?: string;
  onChange: (event: SelectChangeEvent) => void;
}

export const EDIT_OPTIONS_VALUE = 'edit-options';

export default function ActionableSelect({
  inputLabel,
  options,
  disabled,
  editOptions = true,
  editOptionsLabel,
  value,
  tooltipTitle,
  onChange,
}: ActionableSelectProps) {
  return (
    <Fragment>
      {disabled && tooltipTitle ? (
        <Tooltip title={tooltipTitle} arrow placement='top'>
          <FormControl
            sx={{
              minWidth: '256px',
            }}
          >
            <InputLabel className={disabled ? 'MuiInputLabel-disabled' : ''} id={inputLabel}>
              {inputLabel}
            </InputLabel>
            <Select
              id={inputLabel}
              label={inputLabel}
              disabled={disabled}
              value={options.length ? value : ''}
              onChange={onChange}
              IconComponent={KeyboardArrowDownIcon}
              sx={{ backgroundColor: 'white', height: '56px' }}
              autoWidth
            >
              {options.map(({ id, label }) => (
                <MenuItem key={id} value={id} sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  {label}
                  {id === value && <CheckIcon sx={{ color: '#265183' }} />}
                </MenuItem>
              ))}
              {editOptions && editOptionsLabel && (
                <MenuItem value={EDIT_OPTIONS_VALUE}>
                  <AddRoundedIcon sx={{ color: '#265183', marginRight: '8px' }} /> {editOptionsLabel}
                </MenuItem>
              )}
            </Select>
          </FormControl>
        </Tooltip>
      ) : (
        <FormControl
          sx={{
            minWidth: '256px',
          }}
        >
          <InputLabel className={disabled ? 'MuiInputLabel-disabled' : ''} id={inputLabel}>
            {inputLabel}
          </InputLabel>
          <Select
            id={inputLabel}
            label={inputLabel}
            disabled={disabled}
            value={value}
            onChange={onChange}
            IconComponent={KeyboardArrowDownIcon}
            sx={{ backgroundColor: 'white', height: '56px' }}
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: '200px',
                  scrollbarWidth: 'none',
                },
              },
            }}
            autoWidth
          >
            {options.map(({ id, label }) => (
              <MenuItem key={id} value={id} sx={{ display: 'flex', justifyContent: 'space-between' }}>
                {label}
                {id === value && <CheckIcon sx={{ color: '#265183' }} />}
              </MenuItem>
            ))}
            {editOptions && editOptionsLabel && (
              <StickyMenuItem value={EDIT_OPTIONS_VALUE}>
                <AddRoundedIcon sx={{ color: '#265183', marginRight: '8px' }} /> {editOptionsLabel}
              </StickyMenuItem>
            )}
          </Select>
        </FormControl>
      )}
    </Fragment>
  );
}
